import { Typography, theme } from "kosmos-ui/lib";
import reactParser from "html-react-parser";

import {
  RecommendationPosterCardContainer,
  RecommendationCardContainer,
  RecommendationItemCardImg,
  RecommendationArticleCardImgContainer,
} from "./styles";
import { TRecommendationItemCardProps } from "./types";

export function RecommendationPosterCard({
  item,
  render,
  colorTheme = "dark",
  style,
  className,
}: TRecommendationItemCardProps) {
  const description = item.description && reactParser(item.description);

  return (
    <RecommendationPosterCardContainer
      to={item.internalLink || ""}
      style={style?.root || ({} as any)}
      className={className?.root}
    >
      <Typography
        as="b"
        variant="paragraph2"
        style={{
          color:
            colorTheme === "dark"
              ? theme.colorsPalette.white.default
              : theme.colorsPalette.gray.dark,
          ...style?.name,
        }}
        className={className?.name}
      >
        {item.name}
      </Typography>

      {description && (
        <Typography
          as={typeof description === "string" ? "p" : "div"}
          variant="paragraph2"
          style={{
            color:
              colorTheme === "dark"
                ? theme.colorsPalette.gray.light
                : theme.colorsPalette.gray.dark,
            marginTop: 4,
            ...style?.description,
          }}
          className={className?.description}
        >
          {description}
        </Typography>
      )}

      {item.company && (
        <Typography
          as="p"
          variant="paragraph2"
          style={{
            color:
              colorTheme === "dark"
                ? theme.colorsPalette.gray.light
                : theme.colorsPalette.gray.dark,
            marginTop: 4,
            ...style?.company,
          }}
          className={className?.company}
        >
          {item.company.fantasyName}
        </Typography>
      )}

      <RecommendationCardContainer
        to=""
        colortheme={colorTheme}
        render={render}
        as="div"
        style={{ backgroundColor: item.color, ...(style?.card || ({} as any)) }}
        className={className?.card}
      >
        <RecommendationItemCardImg
          src={item.img}
          render={render}
          style={style?.img}
          className={className?.img}
        />
      </RecommendationCardContainer>
    </RecommendationPosterCardContainer>
  );
}

export function RecommendationArticleCard({
  item,
  colorTheme = "dark",
  style,
  className,
}: Omit<TRecommendationItemCardProps, "render">) {
  const description = item.description && reactParser(item.description);

  return (
    <RecommendationCardContainer
      to={item.internalLink || ""}
      colortheme={colorTheme}
      render="article"
      style={style?.root || ({} as any)}
      className={className?.root}
    >
      <RecommendationArticleCardImgContainer
        style={style?.card}
        className={className?.card}
      >
        <RecommendationItemCardImg
          src={item.img}
          render="article"
          style={style?.img}
          className={className?.img}
        />
      </RecommendationArticleCardImgContainer>

      <Typography
        as="p"
        variant="paragraph3"
        style={{
          color:
            colorTheme === "dark"
              ? theme.colorsPalette.gray.lighter
              : theme.colorsPalette.gray.dark,
          marginTop: 16,
          ...style?.name,
        }}
        className={className?.name}
      >
        {item.name}
      </Typography>

      {description && (
        <Typography
          as={typeof description === "string" ? "p" : "div"}
          variant="paragraph3"
          style={{
            color:
              colorTheme === "dark"
                ? theme.colorsPalette.gray.light
                : theme.colorsPalette.gray.default,
            marginTop: 4,
            ...style?.description,
          }}
          className={className?.description}
        >
          {description}
        </Typography>
      )}

      {item.company && (
        <Typography
          as="b"
          variant="paragraph3"
          style={{
            color:
              colorTheme === "dark"
                ? theme.colorsPalette.white.default
                : theme.colorsPalette.gray.default,
            marginTop: 8,
            ...style?.company,
          }}
          className={className?.company}
        >
          {item.company.fantasyName}
        </Typography>
      )}
    </RecommendationCardContainer>
  );
}
